import { AudioFrameExtractor } from './AudioFrameExtractor';
import { ChromeAudioFrameExtractor } from './ChromeAudioFrameExtractor';
export function createAudioFrameExtractor(track, sabHandle) {
    if (typeof MediaStreamTrackProcessor !== 'undefined') {
        return new ChromeAudioFrameExtractor(track);
    }
    return new AudioFrameExtractor(track, sabHandle);
}
